import { Form, Input } from 'antd';

export function InputTextArea({
  name = '',
  label = '',
  required = false,
  showCount = false,
  maxLength = 99999999,
  rows = 4,
}) {
  return (
    <Form.Item name={name} label={label} rules={[{ required, message: `กรุณากรอก${label}` }]}>
      <Input.TextArea rows={rows} showCount={showCount} maxLength={maxLength} placeholder={`กรอก${label}`} />
    </Form.Item>
  );
}
